






import Vue from "vue";
import coreApiClient from "@/services/apis/coreApiClient";
import userManager from "@/services/userManager";
import { displayText, displayItemsWithName } from "@/utils/marketItemDisplay";
import alertStatuses from "@/constants/alertStatuses";
import alertTypes from "@/constants/alertTypes";
import makeSelectOptions from "@common/util/makeSelectOptions";

export default Vue.extend({
  data() {
    return {
      self: this,
      tableOptions: null,
    };
  },
  methods: {
    makeTableOptions() {
      return {
        attrs: {
          "item-key": "_id",
          "sort-by": "time",
          "sort-desc": true,
          "show-select": true,
        },
        content: {
          name: "Cảnh báo",
          urlEnabled: true,
          search: {
            ext: {
              hidden: true,
            },
          },
          filters: {
            filters: {
              time: {
                type: "XDateTimePicker",
                rules: {
                  greater_than_or_equal_to: {
                    attrs: {
                      label: "Thời gian (>=)",
                      xOptions: {
                        content: {
                          resultFilter: (m) => m.startOf("day"),
                        },
                      },
                    },
                  },
                  less_than_or_equal_to: {
                    attrs: {
                      label: "Thời gian (<=)",
                      xOptions: {
                        content: {
                          resultFilter: (m) => m.endOf("day"),
                        },
                      },
                    },
                  },
                },
              },
              resolvedTime: {
                type: "XDateTimePicker",
                rules: {
                  greater_than_or_equal_to: {
                    attrs: {
                      label: "Thời gian xử lý (>=)",
                      xOptions: {
                        content: {
                          resultFilter: (m) => m.startOf("day"),
                        },
                      },
                    },
                  },
                  less_than_or_equal_to: {
                    attrs: {
                      label: "Thời gian xử lý (<=)",
                      xOptions: {
                        content: {
                          resultFilter: (m) => m.endOf("day"),
                        },
                      },
                    },
                  },
                },
              },
              status: {
                type: "selectMultiple",
                attrs: {
                  label: "Trạng thái",
                  items: makeSelectOptions(alertStatuses),
                },
                rules: {
                  in: {},
                },
                ext: {
                  defaultValue: ["pending"],
                },
              },
              type: {
                type: "selectMultiple",
                attrs: {
                  label: "Loại",
                  items: makeSelectOptions(alertTypes),
                },
                rules: {
                  in: {},
                },
                ext: {
                  defaultValue: ["loginDeviceLimitExceeded", "shopWalletTransactionPaymentAccountNotMatch", "paymenTransactionPaymentReceiveAccountNotApproved", "paymentVndTransactionPaymentReceiveAccountNotApproved", "shopWalletTransactionNotSync", "paymentAccountNeedApproved", "paymentReceiveAccountNeedApproved", "airwalletPayoutReceiveAccountNotFound", "airwalletPayoutPartnerNotFound", "airwalletDepositPaymentAccountNotFound", "airwalletUnmatchedDeposit", "airwalletOtherPartnerNotFound"],
                },
              },
              userIds: {
                type: "XAutocomplete",
                attrs: {
                  label: "User",
                  "item-value": "_id",
                  "item-text": "name",
                  multiple: true,
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const { items } = await coreApiClient.call("users", "findAll", {
                          payload: JSON.stringify({
                            search,
                            limit,
                            filters: [
                              {
                                key: "_id",
                                operator: "in",
                                value,
                              },
                            ],
                          }),
                        });
                        return items;
                      },
                    },
                  },
                },
                rules: {
                  in: {},
                },
              },
              shopIds: {
                type: "XAutocomplete",
                attrs: {
                  label: "Shop",
                  "item-value": "_id",
                  "item-text": "name",
                  multiple: true,
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const { items } = await coreApiClient.call("shops", "findAll", {
                          payload: JSON.stringify({
                            search,
                            limit,
                            filters: [
                              {
                                key: "_id",
                                operator: "in",
                                value,
                              },
                            ],
                          }),
                        });
                        return displayItemsWithName(items);
                      },
                    },
                  },
                },
                rules: {
                  in: {},
                },
              },
              marketIds: {
                type: "XAutocomplete",
                attrs: {
                  label: "Thị trường",
                  "item-value": "_id",
                  "item-text": "name",
                  multiple: true,
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const { items } = await coreApiClient.call("markets", "findAll", {
                          payload: JSON.stringify({
                            search,
                            limit,
                            filters: [
                              {
                                key: "_id",
                                operator: "in",
                                value,
                              },
                            ],
                          }),
                        });
                        return items;
                      },
                    },
                  },
                },
                rules: {
                  in: {},
                },
              },
              countryIds: {
                type: "XAutocomplete",
                attrs: {
                  label: "Quốc gia",
                  "item-value": "_id",
                  "item-text": "name",
                  multiple: true,
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const { items } = await coreApiClient.call("countries", "findAll", {
                          payload: JSON.stringify({
                            search,
                            limit,
                            filters: [
                              {
                                key: "_id",
                                operator: "in",
                                value,
                              },
                            ],
                          }),
                        });
                        return items;
                      },
                    },
                  },
                },
                rules: {
                  in: {},
                },
              },
            },
          },
          displayFields: {
            time: {
              text: "Thời gian",
              sortable: true,
              options: {
                filter: "dateTime",
              },
            },
            name: {
              text: "Tên cảnh báo",
              sortable: true,
              hidden: true,
            },
            type: {
              text: "Loại",
              sortable: true,
              options: {
                label(value) {
                  return alertTypes[value || ""] || value;
                },
              },
            },
            description: {
              text: "Mô tả",
              options: {
                html: true,
              },
            },
            status: {
              text: "Trạng thái",
              sortable: true,
              options: {
                label(value) {
                  return alertStatuses[value || ""] || value;
                },
                labelItemColor(value) {
                  if (value === "pending") {
                    return "red";
                  }
                  return "green";
                },
              },
            },
            resolvedTime: {
              text: "Thời gian xử lý",
              sortable: true,
              options: {
                filter: "dateTime",
              },
            },
            users: {
              text: "User",
              options: {
                labels: true,
                labelItems(value) {
                  return value.name;
                },
              },
            },
            markets: {
              text: "Thị trường",
              options: {
                labels: true,
                labelItems(value) {
                  return value.name;
                },
              },
            },
            shops: {
              text: "Shop",
              options: {
                labels: true,
                labelItems(value) {
                  return displayText(value, "name");
                },
              },
            },
            countries: {
              text: "Quốc gia",
              options: {
                labels: true,
                labelItems(value) {
                  return value.name;
                },
              },
            },
            action: {},
          },
          multiSelectActionButtons: {
            resolve: userManager.checkRole(["kt"]) && {
              attrs: {
                color: "default",
                dark: false,
              },
              content: {
                text: "Xử lý",
                icon: "mdi-check",
              },
              target: {
                confirm: {
                  content: {
                    content: {
                      html: "Xác nhận xử lý các cảnh báo đã chọn",
                    },
                  },
                  on: {
                    async xYes({ self: dialog }) {
                      const yesBtn = dialog.yesBtnContainer.value;
                      const btn = dialog.context();
                      const dataTable = btn.context();
                      yesBtn.loading.value = true;
                      const result = await dataTable.execute(
                        async () => {
                          return await coreApiClient.call("alerts", "resolveMany", undefined, {
                            ids: dataTable.model.value.map((item) => item._id),
                          });
                        },
                        undefined,
                        {
                          disableLoading: true,
                          willRefresh: true,
                        }
                      );
                      yesBtn.loading.value = false;
                      if (result) {
                        dialog.hide();
                      }
                    },
                  },
                },
              },
            },
          },
          template: {
            itemActionButtons: {
              delete: userManager.checkRole(["admin"]) && {},
              resolve: userManager.checkRole(["admin", "kt"]) && {
                ext: {
                  condition: (_, item) => {
                    return item.status === "pending";
                  },
                },
                attrs: {},
                content: {
                  icon: "mdi-check",
                },
                on: {
                  async xClick({ self }) {
                    const { dataTable, item } = self.context();
                    await dataTable.execute(
                      async () => {
                        return coreApiClient.call("alerts", "resolve", {
                          id: item._id,
                        });
                      },
                      undefined,
                      {
                        successMessage: `Cảnh báo ${item.name} đã xử lý thành công`,
                        willRefresh: true,
                      }
                    );
                  },
                },
                target: {
                  tooltip: {
                    content: {
                      text: `Xử lý`,
                    },
                  },
                },
              },
            },
          },
        },
        ext: {
          dataProvider: {
            async findAll(options) {
              const { items, count } = await coreApiClient.call("alerts", "findAll", options);
              return [items, count];
            },
            async insert(item) {
              return await coreApiClient.call("alerts", "create", undefined, item);
            },
            async update(item) {
              return await coreApiClient.call(
                "alerts",
                "update",
                {
                  id: item._id,
                },
                {
                  data: item,
                }
              );
            },
            async delete(item) {
              return await coreApiClient.call("alerts", "delete", {
                id: item._id,
              });
            },
          },
          default: {
            delete: {
              confirmDisplayField: "name",
            },
          },
        },
      };
    },
  },
  async created() {
    this.tableOptions = this.makeTableOptions();
  },
});
